// @flow strict

import { en } from './en';
import { de } from './de';

export const localizations = {
  de,
  en,
};
